import * as Immutable from 'immutable';
import { handleActions } from 'redux-actions';

import { NotificationsActionType, NotificationsStore } from './NotificationsReducer.types';

// @ts-ignore
const initialState: NotificationsStore = Immutable.fromJS({
  data: Immutable.List(),
  isFetching: false,
  failure: false,
});

const NotificationsReducer = handleActions(
  {
    DASHBOARD_NOTIFICATIONS_REQUEST: (state: NotificationsStore) => state.set('isFetching', true),

    DASHBOARD_NOTIFICATIONS_RESPONSE_FAILURE: (state: NotificationsStore) => state.set('isFetching', false).set('failure', true),

    AUTHENTICATION_LOGOUT: () => initialState,

    DASHBOARD_NOTIFICATIONS_RESPONSE: (state: NotificationsStore, action: NotificationsActionType) =>
      state.set('isFetching', false).set('data', Immutable.fromJS(action.payload.data.results)).set('failure', false),
  },
  initialState
);

export default NotificationsReducer;
